import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from './Header';
import Footer from './Footer';

import { Outlet } from 'react-router-dom';

const Layout = (props) => {
    const { i18n } = useTranslation();

    return (
        <div className="overflow-hidden" dir={i18n.language === "ar" ? "rtl" : "ltr"}>
            <Header />
            <main
                // className='mt-16'
            >
                <Outlet />
            </main>
            <Footer />
        </div>
    )
}

export default Layout